<section class="dialog-shell" [class]="'dialog-shell dialog-shell--' + data.type">
  <div class="dialog-content">
    <div class="dialog-status" aria-hidden="true">
      <mat-icon>{{ iconName }}</mat-icon>
    </div>

    <div class="dialog-copy">
      <span class="dialog-eyebrow">{{ statusLabel }}</span>
      <h2 id="zignflix-dialog-title">{{ data.title }}</h2>
      @if (data.subtitle) {
        <p>{{ data.subtitle }}</p>
      }
    </div>
  </div>

  <footer class="dialog-actions" [class.dialog-actions--split]="data.type === 'confirmation'">
    @if (data.type === 'confirmation') {
      <button type="button" mat-button class="dialog-action dialog-action--secondary" (click)="onNoClick()">
        {{ data.noButtonText || 'No' }}
      </button>
    }

    <button
      type="button"
      mat-flat-button
      class="dialog-action dialog-action--primary"
      [class.dialog-action--danger]="data.type === 'error'"
      (click)="onYesClick()">
      {{ data.yesButtonText || (data.type === 'confirmation' ? 'Yes' : 'OK') }}
    </button>
  </footer>
</section>
